(function ($) {
    $(function () {
        let $loadMoreBtn = $('#loadMore'),
            newsUrl = 'https://www.dukascopy.com/api/news/',
            branchId = '1',
            iso2 = globalLang,
            start = 0;

        if (sectionId === 15523) {
            $window.on('load', function () {
                getNews(branchId, iso2, start);
                start = 10;
            });
        }

        function getNews(branchId, iso2, start, lines = 10) {
            $.getJSON(`${newsUrl} ${branchId}/${iso2}/${start}/${lines}`)
                .done(function (response) {
                    let resData = response.data;
                    renderNews(resData);
                    if (resData.length < 10) {
                        $loadMoreBtn.hide();
                    }
                });
        }

        function handleText(data) {
            return data.replace(/<p>|<\/p>/g, "");
        }

        function reduceText(data) {
            let maxLength = 240;
            handleText(data);
            if (data.length > maxLength) {
                data = data.substr(0, maxLength);
                data = data.split(' ').slice(0, -1).join(' ') + '...';
            }
            return data;
        }

        function renderNews(data) {
            for (let i = 0; i < data.length; i++) {
                let newsLink = $('<a>', {href: `${data[i].url}`});
                $(newsLink).addClass('news-link');
                let newsItem;
                if (data[i].image === "" || data[i].image === undefined) {
                    newsItem = `<article class="news-article">
                                    <div class="news-article-content">
                                        <span class="date-a">${data[i].date}</span>
                                        <h3 class="h3-a">${data[i].header}</h3>
                                        <div>${reduceText(data[i].text)}</div>
                                    </div>
                                </article>
                `
                } else {
                    newsItem = `<article class="news-article">
                                    <div class="news-article-img" style="background-image: url(${data[i].image})"></div>
                                    <div class="news-article-content">
                                        <span class="date-a">${data[i].date}</span>
                                        <h3 class="h3-a">${data[i].header}</h3>
                                        <div>${reduceText(data[i].text)}</div>
                                    </div>
                                </article>
                `
                }
                $(newsLink).html(newsItem);
                $('#newsBlock').append(newsLink);
                $(newsLink).css("display", "none").fadeIn();
                $('.news-preload').hide();
            }
        }

        $loadMoreBtn.on('click', function (event) {
            event.preventDefault();
            getNews(branchId, iso2, start);
            start += 10;
        });
    });
})(jQuery);